function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 318.5,
  cy: 268.175,
  rx: 318.5,
  ry: 76.7245,
  fill: "url(#paint0_linear_1)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 315.519,
  cy: 243.662,
  rx: 183.689,
  ry: 30.6718,
  fill: "#8BCEFF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  d: "M496.118 240.68C496.118 240.747 496.118 240.815 496.118 240.882C496.118 240.882 455.823 269.222 315.523 269.222C175.223 269.222 134.928 240.882 134.928 240.882C134.928 240.747 134.928 240.613 134.928 240.478C134.928 239.655 134.932 238.834 134.941 238.014C150.816 223.772 225.628 212.99 315.523 212.99C405.417 212.99 480.23 223.772 496.105 238.014C496.114 238.834 496.118 239.655 496.118 240.478L496.118 240.68Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M496.116 240.718C496.116 240.583 496.116 240.448 496.116 240.313C496.116 130.083 415.261 40.7231 315.521 40.7231C215.781 40.7231 134.926 130.083 134.926 240.313C134.926 240.448 134.926 240.583 134.926 240.718C134.926 240.718 175.221 269.057 315.521 269.057C455.821 269.057 496.116 240.718 496.116 240.718Z",
  fill: "url(#paint1_radial)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M496.116 240.516C496.116 240.583 496.116 240.651 496.116 240.718C496.116 240.718 455.821 269.058 315.521 269.058C175.221 269.058 134.926 240.718 134.926 240.718C134.926 240.583 134.926 240.448 134.926 240.313C134.926 239.491 134.93 238.67 134.939 237.85C150.814 223.608 225.626 212.826 315.521 212.826C405.415 212.826 480.228 223.608 496.103 237.85C496.112 238.67 496.116 239.491 496.116 240.313L496.116 240.516Z",
  fill: "#8BCEFF"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.95 245.19V211.917H311.305V245.19H303.95Z",
  fill: "#5851C0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M282.432 245.191H311.57C311.57 237.151 305.047 230.634 297.001 230.634C288.954 230.634 282.432 237.151 282.432 245.191Z",
  fill: "url(#paint2_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M318.466 245.191V211.917H325.82V245.191H318.466Z",
  fill: "#5851C0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M318.465 245.191H347.603C347.603 237.152 341.08 230.634 333.034 230.634C324.988 230.634 318.465 237.152 318.465 245.191Z",
  fill: "url(#paint3_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M267.848 199.266L282.991 181.154L288.635 185.866L273.492 203.977L267.848 199.266Z",
  fill: "#5851C0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.28406,
  ry: 7.27906,
  transform: "matrix(0.956554 -0.291553 0.291995 0.95642 268.886 205.487)",
  fill: "url(#paint4_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.857 198.291L345.779 179.843L340.082 184.491L355.16 202.94L360.857 198.291Z",
  fill: "#5851C0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.28413,
  ry: 7.27899,
  transform: "matrix(0.962798 0.270224 -0.270638 0.962681 359.918 205.258)",
  fill: "url(#paint5_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M346.198 146.109L331.335 136.792C329.274 135.506 326.612 136.998 326.612 139.438V155.57C326.612 156.651 327.163 157.649 328.071 158.215L337.129 163.898L340.75 166.163C342.729 167.408 341.862 170.486 339.526 170.486H329.693C327.989 170.486 326.602 171.886 326.602 173.606V190.056C326.602 197.273 320.451 203.058 313.167 202.368C306.822 201.761 302.099 196.13 302.099 189.696V176.478V170.507V148.755C302.099 147.674 301.548 146.675 300.64 146.109L285.778 136.792C283.717 135.506 281.055 136.998 281.055 139.448V155.58C281.055 156.661 281.606 157.659 282.513 158.226L291.572 163.908L295.193 166.173C297.172 167.419 296.305 170.497 293.969 170.497H284.146C282.442 170.507 281.055 171.897 281.055 173.626V189.336C281.055 207.619 295.234 223.102 313.351 223.647C332.171 224.213 347.656 208.926 347.656 190.056V170.507V148.755C347.656 147.684 347.106 146.675 346.198 146.109Z",
  fill: "url(#paint6_linear)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.14352,
  ry: 6.055,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 172.408 159.387)",
  fill: "#FBB54C"
});

var _ref17 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.14352,
  ry: 6.055,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 215.709 104.669)",
  fill: "#5BD8FF"
});

var _ref18 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.30047,
  ry: 4.2385,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 246.491 134.993)",
  fill: "#40ED9A"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M268.477 123.482H271.018C271.035 123.875 271.199 124.204 271.508 124.471C271.824 124.738 272.254 124.872 272.8 124.872C273.318 124.872 273.738 124.763 274.059 124.545C274.38 124.321 274.543 124.024 274.548 123.654C274.56 123.365 274.464 123.115 274.261 122.902C274.059 122.69 273.676 122.504 273.113 122.346L271.677 121.962C269.622 121.347 268.595 120.241 268.595 118.644C268.595 117.718 268.93 116.944 269.6 116.323C270.27 115.702 271.123 115.34 272.159 115.236V113.447H273.425V115.253C274.41 115.383 275.207 115.757 275.815 116.372C276.423 116.988 276.727 117.775 276.727 118.734H274.202C274.202 118.342 274.067 118.026 273.797 117.786C273.532 117.546 273.155 117.427 272.665 117.427C272.22 117.427 271.852 117.535 271.559 117.753C271.266 117.966 271.12 118.241 271.12 118.579C271.12 119.129 271.548 119.521 272.403 119.756L273.822 120.189C276.052 120.81 277.141 121.97 277.09 123.67C277.085 124.171 276.978 124.626 276.769 125.035C276.567 125.444 276.291 125.784 275.942 126.057C275.598 126.324 275.213 126.539 274.785 126.702C274.363 126.86 273.909 126.964 273.425 127.013V128.941H272.159V127.013C271.038 126.904 270.143 126.528 269.473 125.885C268.809 125.237 268.477 124.436 268.477 123.482Z",
  fill: "#22D07D"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M231.609 103.22H233.135C233.145 103.438 233.243 103.621 233.428 103.77C233.618 103.918 233.876 103.992 234.204 103.992C234.514 103.992 234.766 103.931 234.959 103.81C235.151 103.686 235.249 103.521 235.252 103.316C235.259 103.155 235.202 103.016 235.08 102.898C234.959 102.78 234.729 102.677 234.391 102.589L233.53 102.376C232.297 102.034 231.68 101.419 231.68 100.532C231.68 100.018 231.881 99.588 232.283 99.2429C232.685 98.8979 233.197 98.6966 233.819 98.6391V97.6448H234.579V98.6482C235.17 98.7208 235.648 98.9282 236.013 99.2702C236.377 99.6122 236.56 100.05 236.56 100.582H235.045C235.045 100.364 234.964 100.189 234.802 100.056C234.643 99.9225 234.416 99.8559 234.123 99.8559C233.856 99.8559 233.634 99.9164 233.459 100.037C233.283 100.156 233.195 100.308 233.195 100.496C233.195 100.802 233.452 101.02 233.965 101.15L234.817 101.39C236.154 101.736 236.808 102.38 236.778 103.325C236.774 103.603 236.71 103.856 236.585 104.083C236.463 104.31 236.298 104.499 236.089 104.65C235.882 104.799 235.651 104.918 235.394 105.009C235.141 105.097 234.869 105.154 234.579 105.182V106.253H233.819V105.182C233.146 105.121 232.609 104.912 232.207 104.555C231.809 104.195 231.609 103.75 231.609 103.22Z",
  fill: "#22D07D"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M228.225 159.881H229.75C229.76 160.099 229.858 160.282 230.044 160.43C230.233 160.578 230.491 160.652 230.819 160.652C231.13 160.652 231.381 160.592 231.574 160.471C231.766 160.347 231.864 160.182 231.868 159.976C231.874 159.816 231.817 159.676 231.695 159.558C231.574 159.44 231.344 159.337 231.006 159.249L230.145 159.036C228.912 158.694 228.296 158.08 228.296 157.193C228.296 156.678 228.497 156.248 228.899 155.903C229.3 155.558 229.812 155.357 230.434 155.299V154.305H231.194V155.309C231.785 155.381 232.263 155.589 232.628 155.931C232.993 156.273 233.175 156.71 233.175 157.243H231.66C231.66 157.025 231.579 156.849 231.417 156.716C231.258 156.583 231.032 156.516 230.738 156.516C230.471 156.516 230.25 156.577 230.074 156.698C229.898 156.816 229.811 156.969 229.811 157.156C229.811 157.462 230.067 157.68 230.581 157.81L231.432 158.051C232.77 158.396 233.423 159.041 233.393 159.985C233.389 160.263 233.325 160.516 233.2 160.743C233.079 160.97 232.913 161.159 232.704 161.311C232.498 161.459 232.266 161.579 232.01 161.669C231.756 161.757 231.484 161.815 231.194 161.842V162.913H230.434V161.842C229.762 161.781 229.224 161.573 228.823 161.215C228.424 160.855 228.225 160.41 228.225 159.881Z",
  fill: "#22D07D"
});

var _ref22 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.91482,
  ry: 4.84401,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 213.546 182.097)",
  fill: "#EC6969"
});

var _ref23 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.91482,
  ry: 4.84401,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 159.21 80.0515)",
  fill: "#EC6969"
});

var _ref24 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.37223,
  ry: 7.26601,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 255.313 96.2117)",
  fill: "#EC6969"
});

var _ref25 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.14352,
  ry: 6.055,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 286.162 71.7042)",
  fill: "#40ED9A"
});

var _ref26 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.05617,
  ry: 3.01213,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 311.902 99.8557)",
  fill: "#EC6969"
});

var _ref27 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 1.84306,
  ry: 1.8165,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 192.278 122.005)",
  fill: "#FBB54C"
});

var _ref28 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 1.84306,
  ry: 1.8165,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 392.419 38.1332)",
  fill: "#FBB54C"
});

var _ref29 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.62452,
  ry: 7.51466,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 177.099 208.875)",
  fill: "#5E86EC"
});

var _ref30 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.62452,
  ry: 7.51466,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 206.087 49.413)",
  fill: "#5E86EC"
});

var _ref31 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.14352,
  ry: 5.4495,
  transform: "matrix(0.748955 0.662621 0.663235 -0.748411 205.913 148.162)",
  fill: "#5E86EC"
});

var _ref32 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.28437,
  ry: 6.28055,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 464.449 171.095)",
  fill: "#EC6969"
});

var _ref33 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 5.83549,
  ry: 5.83194,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 414.227 123.994)",
  fill: "#FBB54C"
});

var _ref34 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.60478,
  ry: 3.60259,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 376.47 127.937)",
  fill: "#5E86EC"
});

var _ref35 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.60478,
  ry: 3.60259,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 486.345 130.376)",
  fill: "#5E86EC"
});

var _ref36 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.66783,
  ry: 4.66499,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 506.423 210.057)",
  fill: "#EC6969"
});

var _ref37 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.99939,
  ry: 4.99635,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 401.334 152.507)",
  fill: "#EC6969"
});

var _ref38 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.59107,
  ry: 3.58889,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 430.899 159.49)",
  fill: "#FBB54C"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M407.934 173.782H409.967C409.981 174.109 410.111 174.384 410.359 174.606C410.611 174.829 410.956 174.94 411.393 174.94C411.807 174.94 412.142 174.849 412.399 174.667C412.656 174.481 412.787 174.234 412.791 173.925C412.8 173.684 412.724 173.476 412.561 173.299C412.399 173.121 412.093 172.967 411.643 172.835L410.494 172.515C408.85 172.002 408.028 171.081 408.028 169.75C408.028 168.978 408.296 168.334 408.832 167.816C409.368 167.299 410.05 166.997 410.879 166.91V165.419H411.893V166.924C412.681 167.033 413.318 167.344 413.804 167.857C414.291 168.37 414.534 169.026 414.534 169.825H412.514C412.514 169.498 412.406 169.235 412.19 169.035C411.978 168.835 411.676 168.736 411.285 168.736C410.929 168.736 410.634 168.826 410.399 169.008C410.165 169.185 410.048 169.414 410.048 169.696C410.048 170.154 410.39 170.481 411.075 170.677L412.21 171.037C413.994 171.555 414.865 172.522 414.825 173.939C414.82 174.356 414.735 174.736 414.568 175.076C414.406 175.417 414.185 175.7 413.906 175.927C413.631 176.15 413.323 176.329 412.98 176.465C412.642 176.597 412.28 176.683 411.893 176.724V178.331H410.879V176.724C409.983 176.633 409.267 176.32 408.731 175.784C408.199 175.244 407.934 174.577 407.934 173.782Z",
  fill: "#22D07D"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M418.271 146.637H419.542C419.551 146.811 419.633 146.958 419.787 147.076C419.945 147.195 420.16 147.254 420.433 147.254C420.692 147.254 420.902 147.206 421.063 147.109C421.223 147.01 421.305 146.878 421.307 146.713C421.313 146.585 421.265 146.473 421.164 146.379C421.063 146.285 420.871 146.202 420.59 146.132L419.872 145.961C418.844 145.688 418.331 145.196 418.331 144.487C418.331 144.075 418.498 143.731 418.833 143.455C419.168 143.179 419.595 143.018 420.112 142.972V142.177H420.746V142.979C421.238 143.037 421.637 143.203 421.941 143.477C422.245 143.75 422.397 144.1 422.397 144.527H421.134C421.134 144.352 421.067 144.212 420.932 144.105C420.799 143.999 420.611 143.945 420.366 143.945C420.143 143.945 419.959 143.994 419.813 144.091C419.666 144.185 419.593 144.307 419.593 144.458C419.593 144.702 419.807 144.876 420.235 144.981L420.944 145.173C422.059 145.449 422.604 145.965 422.578 146.72C422.576 146.943 422.522 147.145 422.418 147.327C422.317 147.509 422.179 147.66 422.004 147.781C421.832 147.9 421.64 147.995 421.426 148.068C421.215 148.138 420.988 148.184 420.746 148.206V149.063H420.112V148.206C419.552 148.158 419.105 147.99 418.77 147.705C418.438 147.417 418.271 147.061 418.271 146.637Z",
  fill: "#22D07D"
});

var _ref41 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.59107,
  ry: 3.58889,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 125.091 190.586)",
  fill: "#FBB54C"
});

var _ref42 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.48884,
  ry: 4.48611,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 393.06 80.2763)",
  fill: "#40ED9A"
});

var _ref43 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.48884,
  ry: 4.48611,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 446.683 134.673)",
  fill: "#40ED9A"
});

var _ref44 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.48884,
  ry: 4.48611,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 466.568 92.7521)",
  fill: "#40ED9A"
});

var _ref45 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.03996,
  ry: 4.0375,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 326.658 67.7412)",
  fill: "#5E86EC"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M375.959 99.1797H377.484C377.494 99.3976 377.592 99.5807 377.778 99.729C377.967 99.8773 378.226 99.9515 378.553 99.9515C378.864 99.9515 379.116 99.891 379.308 99.7699C379.501 99.6458 379.599 99.4808 379.602 99.275C379.609 99.1146 379.551 98.9754 379.43 98.8573C379.308 98.7393 379.079 98.6363 378.741 98.5486L377.879 98.3352C376.646 97.9931 376.03 97.3787 376.03 96.4918C376.03 95.9773 376.231 95.5475 376.633 95.2024C377.035 94.8574 377.547 94.6561 378.168 94.5986V93.6042H378.928V94.6076C379.519 94.6803 379.997 94.8876 380.362 95.2297C380.727 95.5717 380.909 96.0091 380.909 96.5418H379.394C379.394 96.3239 379.313 96.1483 379.151 96.0151C378.992 95.8819 378.766 95.8153 378.472 95.8153C378.205 95.8153 377.984 95.8759 377.808 95.997C377.633 96.115 377.545 96.2679 377.545 96.4555C377.545 96.7612 377.802 96.9792 378.315 97.1093L379.166 97.3499C380.504 97.695 381.158 98.3397 381.127 99.2841C381.124 99.5626 381.06 99.8153 380.935 100.042C380.813 100.269 380.648 100.458 380.438 100.61C380.232 100.758 380.001 100.878 379.744 100.969C379.491 101.056 379.219 101.114 378.928 101.141V102.213H378.168V101.141C377.496 101.081 376.959 100.872 376.557 100.514C376.158 100.154 375.959 99.7094 375.959 99.1797Z",
  fill: "#22D07D"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M333.176 99.0619H335.718C335.735 99.4542 335.898 99.7838 336.207 100.051C336.523 100.318 336.953 100.451 337.5 100.451C338.017 100.451 338.437 100.342 338.758 100.124C339.079 99.9009 339.242 99.604 339.248 99.2335C339.259 98.9447 339.163 98.6941 338.96 98.4816C338.758 98.2691 338.375 98.0839 337.812 97.9259L336.376 97.5418C334.321 96.9261 333.294 95.8201 333.294 94.2238C333.294 93.2976 333.629 92.5239 334.299 91.9028C334.969 91.2817 335.822 90.9194 336.858 90.8159V89.0261H338.124V90.8322C339.11 90.963 339.906 91.3362 340.514 91.9519C341.122 92.5675 341.426 93.3548 341.426 94.3137H338.901C338.901 93.9214 338.766 93.6054 338.496 93.3657C338.231 93.126 337.854 93.0061 337.364 93.0061C336.92 93.0061 336.551 93.1151 336.258 93.333C335.965 93.5455 335.819 93.8206 335.819 94.1584C335.819 94.7087 336.247 95.101 337.103 95.3352L338.521 95.7684C340.751 96.3895 341.84 97.55 341.79 99.2498C341.784 99.7511 341.677 100.206 341.469 100.615C341.266 101.023 340.99 101.364 340.641 101.636C340.298 101.903 339.912 102.118 339.484 102.282C339.062 102.44 338.609 102.543 338.124 102.592V104.521H336.858V102.592C335.737 102.483 334.842 102.107 334.172 101.465C333.508 100.816 333.176 100.015 333.176 99.0619Z",
  fill: "#22D07D"
});

var _ref48 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.18214,
  ry: 7.17777,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 458.299 211.227)",
  fill: "#5BD8FF"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.658 179.505H186.2C186.217 179.897 186.38 180.227 186.69 180.494C187.005 180.761 187.436 180.894 187.982 180.894C188.5 180.894 188.919 180.785 189.24 180.567C189.561 180.344 189.724 180.047 189.73 179.676C189.741 179.388 189.646 179.137 189.443 178.925C189.24 178.712 188.857 178.527 188.294 178.369L186.859 177.985C184.804 177.369 183.776 176.263 183.776 174.667C183.776 173.74 184.111 172.967 184.781 172.346C185.451 171.725 186.304 171.362 187.34 171.259V169.469H188.607V171.275C189.592 171.406 190.389 171.779 190.997 172.395C191.605 173.01 191.909 173.798 191.909 174.757H189.384C189.384 174.364 189.249 174.048 188.978 173.809C188.714 173.569 188.337 173.449 187.847 173.449C187.402 173.449 187.033 173.558 186.741 173.776C186.448 173.988 186.301 174.263 186.301 174.601C186.301 175.152 186.729 175.544 187.585 175.778L189.004 176.211C191.233 176.832 192.323 177.993 192.272 179.693C192.266 180.194 192.159 180.649 191.951 181.058C191.748 181.466 191.472 181.807 191.123 182.079C190.78 182.346 190.394 182.561 189.966 182.725C189.544 182.883 189.091 182.986 188.607 183.035V184.964H187.34V183.035C186.22 182.926 185.325 182.55 184.655 181.907C183.99 181.259 183.658 180.458 183.658 179.505Z",
  fill: "#22D07D"
});

var _ref50 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.14219,
  ry: 3.14028,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 364.496 95.5833)",
  fill: "#5BD8FF"
});

var _ref51 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 3.14219,
  ry: 3.14028,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 333.48 19.4952)",
  fill: "#5BD8FF"
});

var _ref52 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 2.24442,
  ry: 2.24305,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 390.148 107.412)",
  fill: "#5E86EC"
});

var _ref53 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 1.79553,
  ry: 1.79444,
  transform: "matrix(0.931677 -0.363287 -0.363809 -0.931474 358.686 73.5434)",
  fill: "#5BD8FF"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.171 154.097C518.171 152.999 518.354 151.946 518.68 150.959L512.978 146.608C511.866 148.863 511.24 151.403 511.24 154.097C511.24 156.789 511.866 159.328 512.975 161.581L518.674 157.222C518.351 156.239 518.171 155.19 518.171 154.097Z",
  fill: "#FBBC05"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M528.18 144.108C530.567 144.108 532.724 144.953 534.418 146.337L539.347 141.419C536.343 138.806 532.493 137.193 528.18 137.193C521.484 137.193 515.73 141.018 512.975 146.609L518.676 150.959C519.99 146.974 523.735 144.108 528.18 144.108Z",
  fill: "#EA4335"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M528.18 164.086C523.736 164.086 519.991 161.22 518.677 157.235L512.975 161.585C515.73 167.176 521.484 171.002 528.18 171.002C532.312 171.002 536.258 169.536 539.219 166.789L533.807 162.608C532.279 163.569 530.356 164.086 528.18 164.086Z",
  fill: "#34A853"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M544.356 154.097C544.356 153.098 544.202 152.022 543.971 151.024H528.184V157.555H537.271C536.817 159.782 535.58 161.494 533.81 162.608L539.223 166.789C542.333 163.904 544.356 159.607 544.356 154.097Z",
  fill: "#4285F4"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.889 141.314C125.983 141.306 125.086 141.424 124.188 141.518C124.015 141.534 123.818 141.581 123.739 141.392C123.645 141.18 123.826 141.054 123.975 140.952C125.093 140.212 126.346 139.921 127.661 139.85C128.566 139.795 129.464 139.834 130.346 140.102C130.748 140.22 130.945 140.456 130.937 140.865C130.889 143.053 130.157 144.957 128.574 146.507C128.519 146.562 128.456 146.609 128.393 146.656C128.251 146.759 128.078 146.853 127.928 146.727C127.787 146.609 127.865 146.436 127.928 146.294C128.393 145.138 128.866 143.989 129.094 142.754C129.125 142.596 129.133 142.439 129.141 142.289C129.149 141.778 128.968 141.558 128.464 141.432C127.936 141.29 127.409 141.314 126.889 141.314Z",
  fill: "#F6A61F"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M120.773 128.11C120.773 129.424 120.82 130.731 120.757 132.045C120.694 133.54 121.151 134.822 122.096 135.955C122.206 136.089 122.308 136.223 122.403 136.364C122.741 136.876 122.678 137.23 122.214 137.623C121.222 138.457 120.237 139.299 119.245 140.133C118.654 140.629 118.284 140.621 117.686 140.133C116.882 139.48 116.252 138.678 115.693 137.82C115.559 137.615 115.489 137.623 115.323 137.781C114.331 138.748 113.284 139.645 111.953 140.094C109.897 140.794 107.811 140.904 105.747 140.173C103.763 139.464 102.574 138.001 102.133 135.963C101.645 133.689 101.897 131.525 103.298 129.598C104.361 128.142 105.834 127.284 107.527 126.757C109.275 126.222 111.079 126.017 112.89 125.836C113.402 125.781 113.906 125.734 114.418 125.687C114.544 125.679 114.654 125.663 114.646 125.498C114.63 124.664 114.717 123.814 114.52 122.996C114.268 121.949 113.583 121.336 112.536 121.108C111.787 120.942 111.047 120.99 110.323 121.233C109.22 121.611 108.535 122.374 108.259 123.507C108.11 124.129 107.818 124.349 107.212 124.286C105.921 124.153 104.629 124.019 103.346 123.885C102.818 123.83 102.542 123.429 102.653 122.917C103.322 119.652 105.464 117.819 108.551 116.977C110.921 116.331 113.323 116.292 115.701 116.961C117.615 117.496 119.221 118.44 120.119 120.313C120.631 121.375 120.749 122.524 120.765 123.673C120.781 125.144 120.765 126.631 120.773 128.11C120.765 128.11 120.773 128.11 120.773 128.11ZM114.646 130.565C114.646 130.172 114.63 129.778 114.654 129.385C114.67 129.141 114.583 129.055 114.339 129.078C113.74 129.133 113.134 129.141 112.536 129.22C111.488 129.354 110.464 129.613 109.614 130.274C108.378 131.242 108.118 132.564 108.322 134.051C108.567 135.798 110.126 136.766 111.795 136.183C112.929 135.79 113.622 134.956 114.103 133.909C114.607 132.847 114.646 131.706 114.646 130.565Z",
  fill: "#050606"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.73 148.325C105.721 148.286 100.327 146.743 95.4525 143.494C94.4602 142.833 93.5153 142.109 92.6175 141.314C92.5388 141.243 92.46 141.173 92.397 141.086C92.3104 140.968 92.2474 140.826 92.3498 140.685C92.4521 140.527 92.6254 140.512 92.775 140.583C93.1215 140.748 93.4523 140.929 93.7909 141.102C96.8936 142.738 100.162 143.919 103.587 144.666C106.69 145.343 109.824 145.658 113.006 145.571C117.549 145.445 121.928 144.532 126.141 142.841C126.346 142.754 126.558 142.668 126.771 142.62C127.07 142.565 127.369 142.605 127.503 142.927C127.629 143.226 127.464 143.462 127.243 143.651C127.086 143.785 126.905 143.895 126.724 144.013C124.007 145.776 121.03 146.909 117.88 147.609C115.801 148.081 113.691 148.309 111.73 148.325Z",
  fill: "#F6A61F"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M283.513 5.71299C282.358 6.23836 281.115 6.59351 279.811 6.7522C281.143 5.93595 282.165 4.64141 282.646 3.09964C281.399 3.85556 280.022 4.40546 278.55 4.70027C277.377 3.41726 275.7 2.61597 273.845 2.61597C270.287 2.61597 267.401 5.57319 267.401 9.22036C267.401 9.73812 267.456 10.2407 267.567 10.7246C262.21 10.4484 257.461 7.82183 254.279 3.82147C253.724 4.80034 253.407 5.93595 253.407 7.14537C253.407 9.43571 254.545 11.4575 256.275 12.6424C255.22 12.6102 254.224 12.3098 253.354 11.8185V11.8997C253.354 15.1007 255.576 17.7707 258.527 18.3756C257.986 18.5306 257.416 18.6081 256.828 18.6081C256.413 18.6081 256.007 18.5683 255.614 18.4908C256.435 21.1138 258.814 23.0242 261.636 23.0752C259.43 24.8478 256.649 25.9039 253.63 25.9039C253.11 25.9039 252.595 25.8737 252.092 25.8131C254.945 27.6838 258.335 28.778 261.973 28.778C273.832 28.778 280.314 18.7155 280.314 9.98732C280.314 9.70011 280.309 9.4129 280.298 9.13133C281.558 8.19979 282.651 7.0377 283.513 5.71299Z",
  fill: "#00AAEC"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M461.399 58.6796C461.399 59.7072 460.564 60.5411 459.536 60.5411H433.453C432.425 60.5411 431.59 59.7072 431.59 58.6796V32.6181C431.59 31.5906 432.425 30.7566 433.453 30.7566H459.536C460.564 30.7566 461.399 31.5906 461.399 32.6181V58.6796Z",
  fill: "#3B5998"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M452.085 60.5411V49.3719H455.811L456.743 44.7181H452.085V42.8565C452.085 40.995 453.018 40.0642 454.88 40.0642H456.743V35.4104C455.811 35.4104 454.656 35.4104 453.017 35.4104C449.593 35.4104 447.427 38.0919 447.427 41.9258V44.7181H443.701V49.3719H447.427V60.5411H452.085Z",
  fill: "white"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M501.918 133.995H504.46C504.477 134.387 504.64 134.717 504.95 134.984C505.265 135.251 505.696 135.384 506.242 135.384C506.76 135.384 507.179 135.275 507.5 135.057C507.821 134.834 507.984 134.537 507.99 134.167C508.001 133.878 507.905 133.627 507.703 133.415C507.5 133.202 507.117 133.017 506.554 132.859L505.119 132.475C503.064 131.859 502.036 130.753 502.036 129.157C502.036 128.231 502.371 127.457 503.041 126.836C503.711 126.215 504.564 125.853 505.6 125.749V123.959H506.867V125.765C507.852 125.896 508.649 126.269 509.257 126.885C509.865 127.501 510.169 128.288 510.169 129.247H507.644C507.644 128.855 507.508 128.539 507.238 128.299C506.974 128.059 506.596 127.939 506.107 127.939C505.662 127.939 505.293 128.048 505 128.266C504.708 128.479 504.561 128.754 504.561 129.092C504.561 129.642 504.989 130.034 505.845 130.268L507.264 130.701C509.493 131.323 510.582 132.483 510.532 134.183C510.526 134.684 510.419 135.139 510.211 135.548C510.008 135.956 509.732 136.297 509.383 136.569C509.04 136.836 508.654 137.051 508.226 137.215C507.804 137.373 507.351 137.476 506.867 137.525V139.454H505.6V137.525C504.48 137.417 503.584 137.041 502.914 136.398C502.25 135.749 501.918 134.948 501.918 133.995Z",
  fill: "#22D07D"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M532.191 188.997H533.717C533.727 189.237 533.825 189.438 534.01 189.602C534.2 189.765 534.458 189.846 534.786 189.846C535.096 189.846 535.348 189.78 535.541 189.646C535.733 189.51 535.831 189.329 535.835 189.102C535.841 188.926 535.784 188.772 535.662 188.643C535.541 188.513 535.311 188.4 534.973 188.303L534.112 188.068C532.879 187.692 532.262 187.016 532.262 186.041C532.262 185.475 532.463 185.002 532.865 184.622C533.267 184.243 533.779 184.021 534.401 183.958V182.864H535.161V183.968C535.752 184.048 536.23 184.276 536.595 184.652C536.959 185.028 537.142 185.51 537.142 186.096H535.627C535.627 185.856 535.546 185.663 535.384 185.516C535.225 185.37 534.998 185.296 534.705 185.296C534.438 185.296 534.216 185.363 534.041 185.496C533.865 185.626 533.777 185.794 533.777 186.001C533.777 186.337 534.034 186.577 534.548 186.72L535.399 186.985C536.736 187.364 537.39 188.073 537.36 189.112C537.356 189.418 537.292 189.696 537.167 189.946C537.045 190.196 536.88 190.404 536.671 190.57C536.464 190.734 536.233 190.865 535.976 190.965C535.723 191.062 535.451 191.125 535.161 191.155V192.333H534.401V191.155C533.728 191.088 533.191 190.858 532.789 190.466C532.391 190.069 532.191 189.58 532.191 188.997Z",
  fill: "#22D07D"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.23 126.247H136.772C136.789 126.639 136.953 126.969 137.262 127.236C137.577 127.503 138.008 127.636 138.554 127.636C139.072 127.636 139.492 127.528 139.813 127.31C140.133 127.086 140.297 126.789 140.302 126.419C140.314 126.13 140.218 125.879 140.015 125.667C139.813 125.454 139.43 125.269 138.867 125.111L137.431 124.727C135.376 124.111 134.349 123.005 134.349 121.409C134.349 120.483 134.684 119.709 135.354 119.088C136.024 118.467 136.877 118.105 137.912 118.001V116.211H139.179V118.018C140.164 118.148 140.961 118.522 141.569 119.137C142.177 119.753 142.481 120.54 142.481 121.499H139.956C139.956 121.107 139.821 120.791 139.551 120.551C139.286 120.311 138.909 120.191 138.419 120.191C137.974 120.191 137.606 120.3 137.313 120.518C137.02 120.731 136.874 121.006 136.874 121.344C136.874 121.894 137.302 122.286 138.157 122.521L139.576 122.954C141.805 123.575 142.895 124.735 142.844 126.435C142.839 126.936 142.732 127.391 142.523 127.8C142.321 128.209 142.045 128.549 141.696 128.821C141.352 129.088 140.967 129.304 140.539 129.467C140.117 129.625 139.663 129.729 139.179 129.778V131.706H137.912V129.778C136.792 129.669 135.897 129.293 135.227 128.65C134.563 128.002 134.23 127.201 134.23 126.247Z",
  fill: "#22D07D"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.156 103.003H104.681C104.692 103.221 104.789 103.404 104.975 103.552C105.164 103.701 105.423 103.775 105.751 103.775C106.061 103.775 106.313 103.714 106.505 103.593C106.698 103.469 106.796 103.304 106.799 103.098C106.806 102.938 106.749 102.799 106.627 102.681C106.505 102.563 106.276 102.46 105.938 102.372L105.077 102.158C103.844 101.816 103.227 101.202 103.227 100.315C103.227 99.8005 103.428 99.3707 103.83 99.0257C104.232 98.6806 104.744 98.4793 105.365 98.4218V97.4275H106.125V98.4309C106.717 98.5035 107.195 98.7109 107.559 99.0529C107.924 99.3949 108.107 99.8323 108.107 100.365H106.592C106.592 100.147 106.511 99.9715 106.348 99.8384C106.19 99.7052 105.963 99.6386 105.669 99.6386C105.403 99.6386 105.181 99.6991 105.006 99.8202C104.83 99.9382 104.742 100.091 104.742 100.279C104.742 100.584 104.999 100.802 105.512 100.933L106.364 101.173C107.701 101.518 108.355 102.163 108.324 103.107C108.321 103.386 108.257 103.639 108.132 103.866C108.01 104.093 107.845 104.282 107.635 104.433C107.429 104.581 107.198 104.701 106.941 104.792C106.688 104.88 106.416 104.937 106.125 104.964V106.036H105.365V104.964C104.693 104.904 104.156 104.695 103.754 104.338C103.356 103.978 103.156 103.533 103.156 103.003Z",
  fill: "#22D07D"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.7695 159.664H101.295C101.305 159.881 101.403 160.065 101.589 160.213C101.778 160.361 102.036 160.435 102.364 160.435C102.675 160.435 102.926 160.375 103.119 160.254C103.311 160.13 103.409 159.965 103.413 159.759C103.419 159.598 103.362 159.459 103.24 159.341C103.119 159.223 102.889 159.12 102.551 159.032L101.69 158.819C100.457 158.477 99.8405 157.863 99.8405 156.976C99.8405 156.461 100.041 156.031 100.443 155.686C100.845 155.341 101.357 155.14 101.979 155.082V154.088H102.739V155.092C103.33 155.164 103.808 155.372 104.173 155.714C104.537 156.056 104.72 156.493 104.72 157.026H103.205C103.205 156.808 103.124 156.632 102.962 156.499C102.803 156.366 102.577 156.299 102.283 156.299C102.016 156.299 101.795 156.36 101.619 156.481C101.443 156.599 101.355 156.752 101.355 156.939C101.355 157.245 101.612 157.463 102.126 157.593L102.977 157.834C104.315 158.179 104.968 158.824 104.938 159.768C104.934 160.046 104.87 160.299 104.745 160.526C104.624 160.753 104.458 160.942 104.249 161.094C104.043 161.242 103.811 161.362 103.555 161.452C103.301 161.54 103.029 161.598 102.739 161.625V162.696H101.979V161.625C101.306 161.564 100.769 161.356 100.367 160.998C99.9688 160.638 99.7695 160.193 99.7695 159.664Z",
  fill: "#22D07D"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M283.281 25.374H284.806C284.817 25.5919 284.914 25.7751 285.1 25.9234C285.289 26.0717 285.548 26.1458 285.876 26.1458C286.186 26.1458 286.438 26.0853 286.63 25.9642C286.823 25.8401 286.921 25.6752 286.924 25.4693C286.931 25.3089 286.874 25.1697 286.752 25.0516C286.63 24.9336 286.401 24.8307 286.063 24.7429L285.202 24.5295C283.969 24.1875 283.352 23.573 283.352 22.6862C283.352 22.1716 283.553 21.7418 283.955 21.3967C284.357 21.0517 284.869 20.8504 285.49 20.7929V19.7986H286.25V20.802C286.842 20.8746 287.32 21.082 287.684 21.424C288.049 21.766 288.232 22.2034 288.232 22.7361H286.717C286.717 22.5182 286.636 22.3426 286.473 22.2095C286.315 22.0763 286.088 22.0097 285.794 22.0097C285.528 22.0097 285.306 22.0702 285.131 22.1913C284.955 22.3093 284.867 22.4622 284.867 22.6499C284.867 22.9556 285.124 23.1735 285.637 23.3037L286.489 23.5443C287.826 23.8893 288.48 24.5341 288.449 25.4784C288.446 25.7569 288.382 26.0096 288.257 26.2366C288.135 26.4637 287.97 26.6528 287.76 26.8042C287.554 26.9525 287.323 27.0721 287.066 27.1629C286.813 27.2506 286.541 27.3081 286.25 27.3354V28.4069H285.49V27.3354C284.818 27.2748 284.281 27.066 283.879 26.7088C283.481 26.3486 283.281 25.9037 283.281 25.374Z",
  fill: "#22D07D"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289.311 9.62489H290.581C290.59 9.79923 290.672 9.94573 290.826 10.0644C290.984 10.183 291.199 10.2424 291.472 10.2424C291.731 10.2424 291.941 10.1939 292.102 10.0971C292.262 9.99779 292.344 9.86582 292.346 9.70116C292.352 9.57282 292.304 9.46144 292.203 9.367C292.102 9.27256 291.91 9.19023 291.629 9.12001L290.911 8.9493C289.883 8.67567 289.37 8.18411 289.37 7.47463C289.37 7.06298 289.537 6.71913 289.872 6.44308C290.207 6.16704 290.634 6.00601 291.152 5.96V5.16455H291.785V5.96727C292.277 6.02538 292.676 6.19125 292.98 6.46488C293.284 6.7385 293.436 7.0884 293.436 7.51458H292.173C292.173 7.34023 292.106 7.19979 291.971 7.09325C291.838 6.9867 291.65 6.93343 291.405 6.93343C291.182 6.93343 290.998 6.98186 290.852 7.07872C290.705 7.17315 290.632 7.29544 290.632 7.44557C290.632 7.69014 290.846 7.86448 291.274 7.9686L291.983 8.16111C293.098 8.43716 293.643 8.95293 293.617 9.70843C293.615 9.9312 293.561 10.1334 293.457 10.315C293.356 10.4966 293.218 10.648 293.043 10.769C292.871 10.8877 292.679 10.9833 292.465 11.056C292.254 11.1262 292.027 11.1722 291.785 11.194V12.0512H291.152V11.194C290.591 11.1456 290.144 10.9785 289.809 10.6927C289.477 10.4046 289.311 10.0486 289.311 9.62489Z",
  fill: "#22D07D"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237.613 15.2003H240.155C240.172 15.5926 240.335 15.9222 240.645 16.1892C240.96 16.4561 241.391 16.5896 241.937 16.5896C242.455 16.5896 242.874 16.4807 243.195 16.2627C243.516 16.0393 243.679 15.7424 243.685 15.3719C243.696 15.0832 243.601 14.8325 243.398 14.6201C243.195 14.4076 242.812 14.2223 242.249 14.0643L240.814 13.6802C238.759 13.0646 237.732 11.9586 237.732 10.3622C237.732 9.43601 238.066 8.66235 238.736 8.04125C239.406 7.42014 240.259 7.05783 241.295 6.95431V5.16455H242.562V6.97066C243.547 7.10142 244.344 7.47463 244.952 8.09028C245.56 8.70594 245.864 9.49322 245.864 10.4521H243.339C243.339 10.0598 243.204 9.74384 242.934 9.50411C242.669 9.26439 242.292 9.14453 241.802 9.14453C241.357 9.14453 240.988 9.25349 240.696 9.47143C240.403 9.68391 240.257 9.95905 240.257 10.2968C240.257 10.8471 240.684 11.2394 241.54 11.4737L242.959 11.9068C245.188 12.5279 246.278 13.6884 246.227 15.3883C246.221 15.8895 246.114 16.3444 245.906 16.7531C245.703 17.1617 245.428 17.5022 245.079 17.7746C244.735 18.0416 244.349 18.2568 243.922 18.4202C243.499 18.5782 243.046 18.6818 242.562 18.7308V20.6595H241.295V18.7308C240.175 18.6218 239.28 18.2459 238.61 17.603C237.945 16.9547 237.613 16.1538 237.613 15.2003Z",
  fill: "#22D07D"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M416.812 51.4041H418.846C418.86 51.731 418.99 52.0057 419.238 52.2282C419.49 52.4507 419.835 52.5619 420.272 52.5619C420.686 52.5619 421.021 52.4711 421.278 52.2895C421.535 52.1033 421.665 51.8559 421.67 51.5472C421.679 51.3065 421.602 51.0977 421.44 50.9206C421.278 50.7435 420.972 50.5892 420.521 50.4575L419.373 50.1374C417.729 49.6244 416.907 48.7027 416.907 47.3724C416.907 46.6006 417.175 45.9559 417.711 45.4383C418.247 44.9207 418.929 44.6187 419.758 44.5325V43.041H420.771V44.5461C421.56 44.6551 422.197 44.9661 422.683 45.4791C423.17 45.9922 423.413 46.6482 423.413 47.4473H421.393C421.393 47.1204 421.285 46.8571 421.069 46.6573C420.857 46.4575 420.555 46.3577 420.163 46.3577C419.808 46.3577 419.513 46.4485 419.278 46.6301C419.044 46.8071 418.927 47.0364 418.927 47.3179C418.927 47.7765 419.269 48.1034 419.954 48.2986L421.089 48.6596C422.873 49.1772 423.744 50.1442 423.703 51.5608C423.699 51.9785 423.613 52.3576 423.447 52.6981C423.285 53.0386 423.064 53.3224 422.785 53.5494C422.51 53.7719 422.201 53.9512 421.859 54.0874C421.521 54.2191 421.159 54.3054 420.771 54.3462V55.9535H419.758V54.3462C418.862 54.2554 418.146 53.9421 417.61 53.4064C417.078 52.8661 416.812 52.1987 416.812 51.4041Z",
  fill: "#22D07D"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M468.512 33.2779H471.054C471.071 33.6702 471.234 33.9998 471.543 34.2668C471.859 34.5338 472.289 34.6673 472.835 34.6673C473.353 34.6673 473.773 34.5583 474.094 34.3404C474.415 34.117 474.578 33.82 474.584 33.4496C474.595 33.1608 474.499 32.9102 474.296 32.6977C474.094 32.4852 473.711 32.3 473.148 32.142L471.712 31.7579C469.657 31.1422 468.63 30.0362 468.63 28.4399C468.63 27.5136 468.965 26.74 469.635 26.1189C470.305 25.4978 471.158 25.1355 472.194 25.032V23.2422H473.46V25.0483C474.446 25.1791 475.242 25.5523 475.85 26.1679C476.458 26.7836 476.762 27.5709 476.762 28.5298H474.237C474.237 28.1375 474.102 27.8215 473.832 27.5818C473.567 27.342 473.19 27.2222 472.7 27.2222C472.256 27.2222 471.887 27.3311 471.594 27.5491C471.301 27.7615 471.155 28.0367 471.155 28.3745C471.155 28.9248 471.583 29.317 472.439 29.5513L473.857 29.9844C476.087 30.6056 477.176 31.766 477.125 33.4659C477.12 33.9671 477.013 34.4221 476.805 34.8307C476.602 35.2393 476.326 35.5798 475.977 35.8523C475.634 36.1192 475.248 36.3344 474.82 36.4979C474.398 36.6559 473.945 36.7594 473.46 36.8084V38.7371H472.194V36.8084C471.073 36.6995 470.178 36.3235 469.508 35.6806C468.844 35.0323 468.512 34.2314 468.512 33.2779Z",
  fill: "#22D07D"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M427.156 24.2589H428.427C428.436 24.4333 428.517 24.5798 428.672 24.6984C428.83 24.8171 429.045 24.8764 429.318 24.8764C429.577 24.8764 429.787 24.828 429.947 24.7311C430.108 24.6318 430.189 24.4999 430.192 24.3352C430.198 24.2069 430.15 24.0955 430.049 24.001C429.947 23.9066 429.756 23.8243 429.474 23.754L428.757 23.5833C427.729 23.3097 427.215 22.8181 427.215 22.1087C427.215 21.697 427.383 21.3532 427.718 21.0771C428.053 20.8011 428.479 20.64 428.997 20.594V19.7986H429.631V20.6013C430.123 20.6594 430.522 20.8253 430.826 21.0989C431.13 21.3725 431.282 21.7224 431.282 22.1486H430.019C430.019 21.9743 429.951 21.8338 429.816 21.7273C429.684 21.6207 429.495 21.5675 429.251 21.5675C429.028 21.5675 428.844 21.6159 428.697 21.7128C428.551 21.8072 428.478 21.9295 428.478 22.0796C428.478 22.3242 428.692 22.4985 429.12 22.6026L429.829 22.7951C430.944 23.0712 431.488 23.587 431.463 24.3425C431.46 24.5652 431.407 24.7674 431.303 24.949C431.201 25.1306 431.063 25.282 430.889 25.4031C430.717 25.5217 430.524 25.6174 430.31 25.69C430.099 25.7602 429.873 25.8062 429.631 25.828V26.6852H428.997V25.828C428.437 25.7796 427.989 25.6125 427.654 25.3268C427.322 25.0386 427.156 24.6827 427.156 24.2589Z",
  fill: "#22D07D"
});

var _ref75 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_1",
  x1: 318.5,
  y1: 174.079,
  x2: 318.5,
  y2: 344.9,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#DCE4FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(324.634 220.372) rotate(90) scale(198.852 199.016)"
}, React.createElement("stop", {
  offset: 0.703125,
  stopColor: "white"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E6EBFF"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 299.293,
  y1: 227.974,
  x2: 292.664,
  y2: 243.317,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7B90FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6F62FF"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 335.326,
  y1: 227.975,
  x2: 328.697,
  y2: 243.318,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7B90FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6F62FF"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 8.43008,
  y1: -2.65966,
  x2: -0.577902,
  y2: 7.76378,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7B90FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6F62FF"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 8.43016,
  y1: -2.65963,
  x2: -0.577703,
  y2: 7.76387,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7B90FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6F62FF"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 319.595,
  y1: 120.363,
  x2: 265.404,
  y2: 168.146,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#7B90FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#6F62FF"
})));

var SvgUbdiIntro = function SvgUbdiIntro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 637,
    height: 345,
    viewBox: "0 0 637 345",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUbdiIntro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ubdiIntro.5e8a013b.svg";
export { ForwardRef as ReactComponent };